define("settings/utils/discount", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class Discount {
    constructor(response) {
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "name", void 0);
      _defineProperty(this, "duration", void 0);
      _defineProperty(this, "endTime", void 0);
      _defineProperty(this, "percentOff", void 0);
      _defineProperty(this, "amountOff", void 0);
      _defineProperty(this, "appliesTo", void 0);
      _defineProperty(this, "totalDiscountAmounts", void 0);
      _defineProperty(this, "totalTaxAmounts", void 0);
      _defineProperty(this, "futureAmountIncludingTax", void 0);
      // flattens discount response from BE by setting private properties on same level and converts to camel case
      this.id = response.discount?.id;
      this.name = response.discount?.name;
      this.duration = response.discount?.duration;
      this.endTime = response.discount?.end_time;
      this.amountOff = response.discount?.amount_off;
      this.appliesTo = response.discount?.applies_to;
      this.percentOff = response.discount?.percent_off;
      this.totalDiscountAmounts = response.total_discount_amounts; //list of {amount: 1234}
      this.totalTaxAmounts = response.total_tax_amounts;
      //Note: this also includes discount subtracted
      this.futureAmountIncludingTax = response.future_amount_including_tax;
    }
    get discountAmount() {
      return this.totalDiscountAmounts?.firstObject?.amount ?? 0;
    }
    get taxAmount() {
      if (!this.totalTaxAmounts.length) {
        return 0;
      }
      return this.totalTaxAmounts.reduce((totalSum, taxAmount) => {
        return totalSum + taxAmount.amount;
      }, 0);
    }
    get futureAmountBeforeTax() {
      return this.futureAmountIncludingTax - this.taxAmount;
    }
  }
  _exports.default = Discount;
});